var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodAppleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "food-apple-outline",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.6668 18.3333C34.0634 13.8783 28.4168 12.265 23.8334 14.6667V5.50001H20.1668V14.6667C15.5834 12.265 9.93678 13.8783 7.33345 18.3333C3.66678 23.8333 12.8334 40.3333 16.5001 40.3333C20.1668 40.3333 20.1668 38.5 22.0001 38.5C23.8334 38.5 23.8334 40.3333 27.5001 40.3333C31.1668 40.3333 40.3334 23.8333 36.6668 18.3333ZM33.4584 24.53C32.3218 29.0583 30.0851 33.22 26.9501 36.6667C26.5834 36.6667 26.1618 36.4833 25.8501 36.2083C23.5951 34.3933 20.4051 34.3933 18.1501 36.2083C17.8384 36.4833 17.4168 36.6667 17.0501 36.6667C13.9151 33.2383 11.6601 29.0583 10.5418 24.5483C10.0834 23.21 9.99178 21.7617 10.3768 20.3867C11.4401 18.4983 13.4201 17.2883 15.5834 17.2333C16.6101 17.2517 17.6184 17.49 18.5351 17.9483L20.1668 18.7733H23.8334L25.4651 17.9483C26.3818 17.49 27.3901 17.2517 28.4168 17.2333C30.5801 17.2883 32.5601 18.48 33.6234 20.3683C34.0084 21.7433 33.9168 23.1917 33.4584 24.53ZM20.1668 9.16668C9.86345 14.795 7.53511 6.93001 7.53511 6.93001C7.53511 6.93001 12.4118 0.348345 20.1668 9.16668Z",
    fill: "url(#paint0_linear_1248_560)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1248_560",
    x1: 17.8027,
    y1: -3.02149,
    x2: 46.6853,
    y2: 7.54489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodAppleOutline);
export default __webpack_public_path__ + "static/media/food-apple-outline.c6fe71a226cbb41165fcde46586b6fc6.svg";
export { ForwardRef as ReactComponent };